import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=c443aca2&scoped=true&lang=pug&"
import script from "./GoodsList.vue?vue&type=script&lang=ts&"
export * from "./GoodsList.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=c443aca2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c443aca2",
  null
  
)

export default component.exports